import { render, staticRenderFns } from "./ShopView.vue?vue&type=template&id=f3a4dc14&scoped=true&"
import script from "./ShopView.vue?vue&type=script&lang=js&"
export * from "./ShopView.vue?vue&type=script&lang=js&"
import style0 from "./ShopView.vue?vue&type=style&index=0&id=f3a4dc14&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3a4dc14",
  null
  
)

export default component.exports